export class UpdateMemberUsageLogRequest {
    UsageLogID: number; //PK of the record
    ParcelBoxInches?: number;
    FullSizeImage?: boolean;
    DownloadImageParameters: string;
    OverwriteSearchAddress: string;
}
